import {createSelector} from 'reselect'
import pendingRequestsSelector from './pendingRequestsSelector'
import { API_URL_MODELS } from '../../../constants/apiUrls'
import requestIsPending from './helpers/requestIsPending'

const allModelsRequestIsPendingSelector = createSelector(
    pendingRequestsSelector,
    (pendingRequests): boolean => requestIsPending(pendingRequests, API_URL_MODELS),
)

export default allModelsRequestIsPendingSelector
